/** The search of `/$org/conversations` opening one thread, every other filter unset. */
export function conversationSearch(conversation: string) {
    return {
        conversation,
        status: undefined,
        channel: undefined,
        resolution: undefined,
        asset: undefined,
        unattached: undefined,
        draft: undefined,
        q: undefined,
        selected: undefined,
        reply_for_issue: undefined,
        message: undefined,
    }
}
